{
	"title": "Verzendregels",
	"description": "Verzendkosten en de gratis-vanaf-drempel per land en klantgroep.",
	"intro": "Per land en klantgroep: wat verzenden kost en vanaf welk bedrag aan producten het gratis is. Staat verzenden uit bij een zakelijke groep, dan geldt de regel van Consument.",
	"country": {
		"NL": "Nederland",
		"BE": "België"
	},
	"basis": {
		"inclVat": "Bedragen incl. btw",
		"exclVat": "Bedragen excl. btw"
	},
	"field": {
		"ships": "Verzenden",
		"rate": "Verzendkosten",
		"freeFrom": "Gratis vanaf",
		"freeFromDescription": "Leeg: geen gratis verzending. De shop toont dan ook geen balk \"Nog € … tot gratis verzending\"."
	},
	"notShipped": "Verzendt niet",
	"submit": "Opslaan",
	"groupGone": "Een klantgroep bestaat niet meer. Laad de pagina opnieuw.",
	"help": {
		"shippingRules": {
			"title": "Verzendregels",
			"area": "Instellingen › Verzendregels",
			"short": "Per land en klantgroep: of je verstuurt, wat verzenden kost en vanaf welk bedrag het gratis is. De mand rekent ermee, en de shop toont wat er nog nodig is voor gratis verzending.",
			"warning": "Staat verzenden uit bij een zakelijke groep, dan geldt de regel van Consument, omgerekend naar excl. btw. Staat het ook bij Consument uit, dan kan niemand naar dat land bestellen.",
			"terms": ["price:customerGroup", "shippingRule:rule", "shippingRule:freeFrom"]
		},
		"rule": {
			"title": "Verzendregel",
			"area": "Instellingen › Verzendregels",
			"short": "Eén regel per land en klantgroep, in de bedragen van die groep: incl. btw voor Consument, excl. btw voor een zakelijke groep.",
			"choices": [
				{
					"name": "Verzenden",
					"text": "Aan: deze groep heeft een eigen regel voor dit land. Uit: Consument verzendt niet, of een zakelijke groep volgt Consument."
				},
				{
					"name": "Verzendkosten",
					"text": "Wat de klant betaalt voor verzenden, zolang het niet gratis is."
				},
				{
					"name": "Gratis vanaf",
					"text": "Vanaf dit bedrag aan producten is verzenden gratis. Leeg: nooit gratis."
				}
			],
			"terms": ["price:customerGroup", "shippingRule:freeFrom"]
		},
		"freeFrom": {
			"title": "Gratis vanaf",
			"area": "Instellingen › Verzendregels",
			"short": "Halen de producten in de mand dit bedrag, dan is verzenden gratis. Het telt na een kortingscode. Tot die tijd toont de shop in de mand hoeveel er nog nodig is.",
			"warning": "Precies het bedrag telt al: bij gratis vanaf €40 is een mand van €40,00 gratis."
		}
	},
	"helpExample": {
		"sandbox": "Kies de drempel en wat er in de mand zit.",
		"freeFrom": "Gratis vanaf (€)",
		"goods": "Producten in de mand (€)",
		"invalid": "Vul een bedrag in, zoals 40 of 40,00.",
		"label": "De verzendbalk in de mand: {{text}}"
	}
}
